import {Component, Inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UntypedFormControl, Validators} from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-proceed-confirmation',
  templateUrl: './proceed-confirmation.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./proceed-confirmation.component.scss']
})
export class ProceedConfirmationComponent implements OnInit {

  public confirmationFormControl: UntypedFormControl;
  public confirmationText: string;
  public proceedText: string;

  constructor(
    public dialogRef: MatDialogRef<ProceedConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string,
  ) {
  }

  ngOnInit(): void {
    this.proceedText = this.data || 'with this action';
    this.confirmationText = 'proceed';
    this.confirmationFormControl = new UntypedFormControl(null, [Validators.required, Validators.pattern(this.confirmationText)]);
  }


  verify(): boolean {
    if (this.confirmationFormControl.valid) {
      return this.confirmationFormControl.value === this.confirmationText;
    }
    return false;
  }

  confirm(): void {
    if (this.confirmationFormControl.valid) {
      if (this.verify()) {
        this.dialogRef.close(true);
      } else {
        this.confirmationFormControl.reset();
      }
    }
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
